(() => {
  function moneyFormat(cents) {
    const rawFormat = window.dfShopTheLookMoneyFormat || "£{{amount}}";
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return rawFormat.replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  async function addToCart(variantId) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    });

    if (!response.ok) throw new Error("Add to cart failed");

    const data = await response.json();

    if (typeof window.dfSyncCartIconBubble === "function") {
      await window.dfSyncCartIconBubble();
    }

    if (typeof window.openDeframeCart === "function") {
      window.openDeframeCart();
    }

    return data;
  }

  async function addMultipleToCart(variantIds) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: variantIds.map((id) => ({
          id: Number(id),
          quantity: 1
        }))
      })
    });

    if (!response.ok) throw new Error("Add look failed");

    const data = await response.json();

    if (typeof window.dfSyncCartIconBubble === "function") {
      await window.dfSyncCartIconBubble();
    }

    if (typeof window.openDeframeCart === "function") {
      window.openDeframeCart();
    }

    return data;
  }

  function normalizeProduct(product) {
    if (!product) return null;

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const hasRealVariants = variants.some((v) => v.title !== "Default Title");

    return {
      ...product,
      hasRealVariants,
      firstAvailableVariant: variants.find((v) => v.available) || variants[0] || null
    };
  }

  function initSection(section) {
    const track = section.querySelector("[data-looks-track]");
    const looks = Array.from(section.querySelectorAll(".df-stl__look"));
    const prevBtn = section.querySelector(".df-stl__nav--prev");
    const nextBtn = section.querySelector(".df-stl__nav--next");
    const overlay = section.querySelector("[data-stl-overlay]");
    const drawer = section.querySelector("[data-stl-drawer]");
    const sheet = section.querySelector("[data-stl-sheet]");

    const panel = {
      lookLabel: section.querySelector("[data-panel-look-label]"),
      lookCount: section.querySelector("[data-panel-look-count]"),
      lookTotal: section.querySelector("[data-panel-look-total]"),
      products: section.querySelector("[data-panel-products]")
    };

    const mobile = {
      lookLabel: section.querySelector("[data-sheet-look-label]"),
      lookCount: section.querySelector("[data-sheet-look-count]"),
      lookTotal: section.querySelector("[data-sheet-look-total]"),
      products: section.querySelector("[data-sheet-products]")
    };

    const panelAddLook = section.querySelector("[data-panel-add-look]");
    const sheetAddLook = section.querySelector("[data-sheet-add-look]");

    let selectedVariants = [];

    const state = {
      currentLookIndex: 0,
      previewLookIndex: null,
      expandedMobileLookIndex: null
    };

    const looksData = looks.map((look) => {
      const dataTag = look.querySelector(".df-stl__look-data");
      const parsed = JSON.parse(dataTag.textContent || "{}");

      return {
        label: parsed.label || "",
        productCount: Number(parsed.productCount || 0),
        totalPrice: Number(parsed.totalPrice || 0),
        image:
          look.querySelector(".df-stl__image--desktop")?.src ||
          look.querySelector(".df-stl__image--mobile")?.src ||
          "",
        products: (parsed.products || []).map(normalizeProduct).filter(Boolean)
      };
    });

    function isMobile() {
      return window.matchMedia("(max-width: 989px)").matches;
    }

    function setCurrentLook(index) {
      state.currentLookIndex = Math.max(0, Math.min(index, looks.length - 1));

      looks.forEach((look, i) => {
        look.classList.toggle("is-current", i === state.currentLookIndex);
      });
    }

    function clearPreview() {
      looks.forEach((look) => look.classList.remove("is-preview"));
      state.previewLookIndex = null;
    }

    function previewLook(index) {
      clearPreview();

      if (index == null || index < 0 || index >= looks.length) return;

      looks[index].classList.add("is-preview");
      state.previewLookIndex = index;
    }

    function expandMobileLook(index) {
      looks.forEach((look, i) => {
        look.classList.toggle("is-expanded", i === index);
      });

      state.expandedMobileLookIndex = index;
    }

    function resetAddLookButtons() {
      selectedVariants = [];

      [panelAddLook, sheetAddLook].forEach((button) => {
        if (!button) return;

        button.disabled = true;
        button.innerHTML = `<span class="df-stl__add-look-left">SELECT ALL SIZES</span>`;
      });
    }

    function closeAllPanels() {
      overlay.hidden = true;

      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");

      sheet.classList.remove("is-open");
      sheet.setAttribute("aria-hidden", "true");

      looks.forEach((look) => look.classList.remove("is-expanded"));
      state.expandedMobileLookIndex = null;

      clearPreview();
      resetAddLookButtons();
    }

    function getAddLookButtonForContainer(container) {
      if (container === panel.products) return panelAddLook;
      if (container === mobile.products) return sheetAddLook;
      return null;
    }

    function updateAddLookState(container, look) {
      const button = getAddLookButtonForContainer(container);
      if (!button || !look) return;

      const items = Array.from(container.querySelectorAll(".df-stl__stack-item"));
      const ids = items
        .map((item) => item.dataset.selectedVariantId)
        .filter(Boolean);

      selectedVariants = ids;

      const allSelected = ids.length === items.length && items.length > 0;

      button.disabled = !allSelected;
      button.innerHTML = allSelected
  ? `<span class="df-stl__add-look-left">ADD LOOK</span>
     <span class="df-stl__add-look-right">${moneyFormat(look.totalPrice)}</span>`
  : `<span class="df-stl__add-look-left">SELECT ALL SIZES</span>`;
    }

    function renderStackedProducts(container, look) {
      if (!container || !look) return;

      container.innerHTML = "";
      resetAddLookButtons();

      look.products.forEach((product) => {
        const item = document.createElement("div");
        item.className = "df-stl__stack-item";

        let badgeHTML = '';

if (!product.available || product.restockLocked) {
  badgeHTML = '<span class="df-badge df-badge--soldout">Sold out</span>';
} else if (product.isOnSale) {
  badgeHTML = '<span class="df-badge df-badge--sale">Sale</span>';
}

        const gallery = document.createElement("div");
        gallery.className = "df-stl__stack-gallery";

        const imageList =
          Array.isArray(product.images) && product.images.length
            ? product.images
            : [product.featuredImage].filter(Boolean);

        imageList.forEach((src) => {
          const image = document.createElement("img");
          image.className = "df-stl__stack-image";
          image.src = src;
          image.alt = product.title || "";
          image.draggable = false;
          gallery.appendChild(image);
        });

        const title = document.createElement("div");
        title.className = "df-stl__stack-title";
        title.textContent = product.title || "";

        const price = document.createElement("div");
        price.className = "df-stl__stack-price";
        if (product.isOnSale && product.compareAtPrice) {
  price.innerHTML =
    '<span class="df-price--compare">' +
    moneyFormat(product.compareAtPrice) +
    '</span> ' +
    '<span class="df-price--sale">' +
    moneyFormat(product.price) +
    '</span>';
} else {
  price.textContent = moneyFormat(product.price);
}

        const label = document.createElement("div");
        label.className = "df-stl__stack-label";
        label.textContent = "SELECT SIZE";

        const sizes = document.createElement("div");
        sizes.className = "df-stl__stack-sizes";

        const variants = Array.isArray(product.variants) ? product.variants : [];
        const hasAvailable =
  !product.restockLocked &&
  variants.some((variant) => variant.available);

        const add = document.createElement("button");
        add.type = "button";
        add.className = "df-stl__stack-add";
        add.disabled = true;

        if (!hasAvailable) {
          add.classList.add("is-sold-out");
          add.textContent = "SOLD OUT";
        } else {
          add.textContent = "SELECT SIZE";
        }

        let selectedVariantId = null;

        if (product.hasRealVariants) {
          variants.forEach((variant) => {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "df-stl__stack-size";
            btn.dataset.variantId = variant.id;
            btn.textContent = variant.option1 || variant.title;

            if (!variant.available || product.restockLocked) {
  btn.classList.add("is-unavailable");
}

btn.addEventListener("click", () => {
  if (!variant.available || product.restockLocked) return;

              sizes.querySelectorAll(".df-stl__stack-size").forEach((el) => {
                el.classList.remove("is-active");
                el.classList.remove("is-selected");
              });

              btn.classList.add("is-active");
              btn.classList.add("is-selected");

              selectedVariantId = variant.id;
              item.dataset.selectedVariantId = variant.id;

              add.disabled = false;
              add.classList.remove("is-sold-out");
              add.textContent = "ADD";

              updateAddLookState(container, look);
            });

            sizes.appendChild(btn);
          });
        } else if (product.firstAvailableVariant) {
          selectedVariantId = product.firstAvailableVariant.id;

          if (product.firstAvailableVariant.available && !product.restockLocked) {
  item.dataset.selectedVariantId = product.firstAvailableVariant.id;
  add.disabled = false;
  add.textContent = "ADD";
} else {
            add.disabled = true;
            add.classList.add("is-sold-out");
            add.textContent = "SOLD OUT";
          }
        }

        add.addEventListener("click", async () => {
          if (add.classList.contains("is-sold-out")) return;
          if (!selectedVariantId) return;

          const matchedVariant = variants.find((v) => String(v.id) === String(selectedVariantId));

          if (product.restockLocked || (matchedVariant && !matchedVariant.available)) {
  add.classList.add("is-sold-out");
  add.disabled = true;
  add.textContent = "SOLD OUT";
  return;
}

          add.disabled = true;
          add.textContent = "ADDING";

          try {
            await addToCart(selectedVariantId);
            closeAllPanels();
          } catch (e) {
            console.error(e);
            add.disabled = false;
            add.textContent = "ADD";
          }
        });

        if (badgeHTML) {
  const badgeWrapper = document.createElement("div");
  badgeWrapper.innerHTML = badgeHTML;
  item.appendChild(badgeWrapper.firstChild);
}

item.appendChild(gallery);
        item.appendChild(title);
        item.appendChild(price);
        item.appendChild(label);
        item.appendChild(sizes);
        item.appendChild(add);

        container.appendChild(item);
      });

      updateAddLookState(container, look);
    }

    function populateDesktopDrawer(lookIndex) {
      const look = looksData[lookIndex];
      if (!look) return;

      state.currentLookIndex = lookIndex;

      panel.lookLabel.textContent = look.label;
      panel.lookCount.textContent =
        look.productCount + " PRODUCT" + (look.productCount === 1 ? "" : "S");
      panel.lookTotal.textContent = "TOTAL PRICE: " + moneyFormat(look.totalPrice);

      renderStackedProducts(panel.products, look);

      overlay.hidden = false;
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
    }

    function populateMobileSheet(lookIndex) {
      const look = looksData[lookIndex];
      if (!look) return;

      state.currentLookIndex = lookIndex;

      mobile.lookLabel.textContent = look.label;
      mobile.lookCount.textContent =
        look.productCount + " PRODUCT" + (look.productCount === 1 ? "" : "S");
      mobile.lookTotal.textContent = "TOTAL PRICE: " + moneyFormat(look.totalPrice);

      renderStackedProducts(mobile.products, look);

      overlay.hidden = false;
      sheet.classList.add("is-open");
      sheet.setAttribute("aria-hidden", "false");
    }

    looks.forEach((look, index) => {
      if (!isMobile()) {
        look.addEventListener("mouseenter", () => {
          previewLook(index);
        });

        look.addEventListener("mouseleave", () => {
          if (!drawer.classList.contains("is-open")) {
            clearPreview();
          }
        });
      }

      look.addEventListener("click", () => {
        if (isMobile()) {
          const isAlreadyPreview = state.previewLookIndex === index;

          if (!isAlreadyPreview) {
            previewLook(index);
            setCurrentLook(index);
            return;
          }

          populateMobileSheet(index);
          expandMobileLook(index);
          setCurrentLook(index);
          return;
        }

        previewLook(index);
        populateDesktopDrawer(index);
        looks[index].classList.add("is-expanded");
      });

      look.addEventListener("focus", () => {
        if (!isMobile()) previewLook(index);
      });
    });

    section.querySelector("[data-close-drawer]")?.addEventListener("click", closeAllPanels);
    section.querySelector("[data-close-sheet]")?.addEventListener("click", closeAllPanels);
    overlay?.addEventListener("click", closeAllPanels);

    [panelAddLook, sheetAddLook].forEach((button) => {
      button?.addEventListener("click", async () => {
        if (!selectedVariants.length) return;

        button.disabled = true;
        button.textContent = "ADDING";

        try {
          await addMultipleToCart(selectedVariants);
          closeAllPanels();
        } catch (e) {
          console.error(e);
          button.disabled = false;
          button.textContent = "ADD LOOK";
        }
      });
    });

    document.addEventListener("click", (event) => {
      const insideSection = event.target.closest(`#${section.id}`);
      if (insideSection) return;
      if (drawer.classList.contains("is-open") || sheet.classList.contains("is-open")) return;
      clearPreview();
    });


const viewport = section.querySelector("[data-looks-viewport]");

prevBtn?.addEventListener("click", () => {
  if (!viewport) return;

  if (isMobile()) {
    const nextIndex =
      state.currentLookIndex <= 0
        ? looks.length - 1
        : state.currentLookIndex - 1;

    state.currentLookIndex = nextIndex;
    setCurrentLook(nextIndex);

    const slideWidth = viewport.offsetWidth;

    viewport.scrollTo({
      left: nextIndex * slideWidth,
      behavior: "smooth"
    });

    return;
  }

  const nextIndex = Math.max(0, state.currentLookIndex - 1);

  setCurrentLook(nextIndex);

  viewport.scrollTo({
    left: looks[nextIndex].offsetLeft,
    behavior: "smooth"
  });

  window.setTimeout(() => {
    previewLook(nextIndex);
  }, 220);
});

nextBtn?.addEventListener("click", () => {
  if (!viewport) return;

  if (isMobile()) {
    const nextIndex =
      state.currentLookIndex >= looks.length - 1
        ? 0
        : state.currentLookIndex + 1;

    state.currentLookIndex = nextIndex;
    setCurrentLook(nextIndex);

    const slideWidth = viewport.offsetWidth;

    viewport.scrollTo({
      left: nextIndex * slideWidth,
      behavior: "smooth"
    });

    return;
  }

  const nextIndex = Math.min(looks.length - 1, state.currentLookIndex + 1);

  setCurrentLook(nextIndex);

  viewport.scrollTo({
    left: looks[nextIndex].offsetLeft,
    behavior: "smooth"
  });

  window.setTimeout(() => {
    previewLook(nextIndex);
  }, 220);
});

setCurrentLook(0);

if (viewport && isMobile()) {
  viewport.addEventListener(
    "scroll",
    () => {
      const slideWidth = viewport.offsetWidth;
      if (!slideWidth) return;

      const index = Math.round(viewport.scrollLeft / slideWidth);
      setCurrentLook(index);
    },
    { passive: true }
  );
}

  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".df-stl").forEach(initSection);
  });
})();